import { render } from "./IntegrationItem.vue?vue&type=template&id=6cf28c8e"
import script from "./IntegrationItem.vue?vue&type=script&lang=js"
export * from "./IntegrationItem.vue?vue&type=script&lang=js"

import "./IntegrationItem.vue?vue&type=style&index=0&id=6cf28c8e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__